export default "__VITE_ASSET__Cb$VERu8__"